/* Bestikbakke: tilkøb i kurven og pasform-tjek (stor/lille). Køres før kernen. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('ele-lp-config'); if (!cfgEl) return;
  var C = JSON.parse(cfgEl.textContent);
  function kr(ore) { var v = (ore / 100).toFixed(2).split('.'); return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1] + ' kr'; }
  /* Stor i kurven og ingen pakke: tilbyd at skifte til pakken med foliebakke */
  window.eleLpUpsell = function (cart, qtyOf) { return qtyOf(C.ids.stor) > 0 && !qtyOf(C.ids.pakke) ? 'swap' : null; };
  window.eleLpFit = function (h) {
    var $ = h.$, SIZES = { stor: { min: 35, max: 58, d: 43, h: 6.5 }, lille: { min: 29.7, max: 41, d: 33.5, h: 5 } };
    var form = $('[data-fit-form]'), out = $('[data-fit-result]'), chart = $('[data-chart]');
    if (!form) return;
    function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) && n > 0 ? n : null; }
    function cm(n) { return String(Math.round(n * 10) / 10).replace('.', ',') + ' cm'; }
    function fits(s, w, d, hh) { return w >= SIZES[s].min && d >= SIZES[s].d && (hh === null || hh >= SIZES[s].h); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var w = num(form.w.value), d = num(form.d.value), hh = num(form.h.value);
      if (!w || !d) { out.textContent = 'Skriv mindst bredde og dybde i cm.'; return; }
      var max = Math.max(60, Math.ceil(Math.max(w, d) / 15) * 15);
      chart.style.setProperty('--max', max);
      var axis = document.querySelector('.chart__axis');
      if (axis) axis.innerHTML = [0, 1, 2, 3, 4].map(function (i) { return '<span>' + (max / 4 * i) + (i === 4 ? ' cm' : '') + '</span>'; }).join('');
      [['w', w], ['d', d]].forEach(function (p) {
        var row = chart.querySelector('[data-you="' + p[0] + '"]'); row.hidden = false;
        row.querySelector('.chart__fill').style.setProperty('--v', p[1]);
        row.querySelector('.chart__val').textContent = 'Din skuffe: ' + cm(p[1]);
      });
      var stor = fits('stor', w, d, hh), lille = fits('lille', w, d, hh), pick = null, msg = '';
      if (stor) { pick = 'stor'; msg = '<strong>Den store passer.</strong> ' + (w > SIZES.stor.max ? 'Din skuffe er ' + cm(w) + ' bred, så der bliver ' + cm(w - SIZES.stor.max) + ' tom plads ved siden af bakken.' : 'Træk siderne ud til ' + cm(w) + '.'); }
      else if (lille) { pick = 'lille'; msg = '<strong>Vælg den lille.</strong> ' + (d < SIZES.stor.d ? 'Den store er 43 cm dyb, og din skuffe er ' + cm(d) + '.' : 'Din skuffe er for smal til den store (min. 35 cm).') + (w > SIZES.lille.max ? ' Der bliver ' + cm(w - SIZES.lille.max) + ' tom plads ved siden af.' : ''); }
      else {
        var why = [];
        if (w < SIZES.lille.min) why.push('bredden er under 29,7 cm');
        if (d < SIZES.lille.d) why.push('dybden er under 33,5 cm');
        if (hh !== null && hh < SIZES.lille.h) why.push('den frie højde er under 5 cm');
        msg = '<strong>Ingen af dem passer.</strong> ' + (why.length ? 'Fordi ' + why.join(' og ') + '.' : '') + ' Skriv til info@eleleving.com, så hjælper vi.';
      }
      out.innerHTML = msg + (pick ? '<br><a class="btn btn--primary" href="#koeb" data-fit-pick="' + pick + '">Vælg ' + (pick === 'stor' ? 'den store, ' : 'den lille, ') + kr(C.plans[pick].price) + '</a>' : '');
      var a = out.querySelector('[data-fit-pick]'); if (a) a.addEventListener('click', function () { h.selectPlan(pick); });
    });
  };
})();

/* élé living, CRO-landingsside (Shopify-tema-version, okt 2026). Fælles kerne for bestikbakke og Multi organizer.
   Kurven er Shopifys rigtige kurv (Ajax Cart API). Findes élés Rebuy Smart Cart, åbnes den, ellers sidens egen skuffe.
   Valg, priser og variant-ID'er kommer fra produkterne via <script id="ele-lp-config"> (Liquid).
   Uden JS poster formularerne til /cart/add, og Shopify sender kunden til /cart.
   Pixel: Shopifys kundeevents (Meta-kanalen) fanger sidevisning og læg-i-kurv. Events skubbes også til dataLayer. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('ele-lp-config');
  if (!cfgEl) return;
  var C = JSON.parse(cfgEl.textContent);
  var PLANS = C.plans, FREE = C.freeOver, SHIP = C.ship;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function kr(ore) { var v = (Math.abs(ore) / 100).toFixed(2).split('.'); return (ore < 0 ? '-' : '') + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1] + ' kr'; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shippingFor(sub) { return sub > FREE ? 0 : SHIP; }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.dataLayer = window.dataLayer || [];
  function track(name, items, value) {
    window.dataLayer.push({ event: name, ecommerce: { currency: 'DKK', value: value / 100, items: items.map(function (i) { return { item_id: String(i.id), quantity: i.quantity }; }) } });
  }

  /* ---------- Shopify Ajax Cart ---------- */
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function api(path, body) {
    return fetch(ROOT_URL + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin'
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Der skete en fejl'); return j; }); });
  }
  var cart = { items: [], item_count: 0, total_price: 0 };
  function qtyOf(id) { return (cart.items || []).reduce(function (a, it) { return a + (it.variant_id === id ? it.quantity : 0); }, 0); }

  /* ---------- købsboks ---------- */
  var selected = C.defaultPlan;
  function renderBuy() {
    var p = PLANS[selected];
    $$('[data-buy-price]').forEach(function (el) { el.textContent = kr(p.price); });
    var sn = $('[data-ship-note]'); if (sn) sn.textContent = shippingFor(p.price) ? '+ fragt' : 'fri fragt til pakkeshop';
    var note = $('[data-tier-note]'); if (note) note.textContent = p.note;
    var sp = $('[data-sticky-price]'); if (sp) sp.textContent = kr(p.price);
    var sname = $('[data-sticky-name]'); if (sname) sname.textContent = p.label;
    var fid = $('[data-form-id]'), fq = $('[data-form-qty]');
    if (fid) fid.value = String(p.items[0].id);
    if (fq) fq.value = String(p.items[0].quantity);
  }
  function selectPlan(key) { if (!PLANS[key]) return; selected = key; var r = $('[data-buy-form] input[data-plan="' + key + '"]'); if (r) r.checked = true; renderBuy(); }
  $$('[data-buy-form] input[data-plan]').forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) selectPlan(r.dataset.plan); });
    if (r.checked) selected = r.dataset.plan;
  });
  $$('[data-pick-plan]').forEach(function (a) { a.addEventListener('click', function () { selectPlan(a.dataset.pickPlan); }); });

  /* ---------- kurv: élés Rebuy, ellers egen skuffe ---------- */
  var drawer = $('#cart'), overlay = $('[data-cart-overlay]'), lastFocus = null;
  function showError(msg) { var e = $('[data-cart-error]'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  function rebuyCart() { var R = window.Rebuy; return R && R.SmartCart && typeof R.SmartCart.show === 'function' ? R.SmartCart : null; }
  function renderCart() {
    var count = cart.item_count || 0, sub = cart.total_price || 0, ship = count ? shippingFor(sub) : 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = String(count); });
    var ob = $('[data-cart-open]'); if (ob) ob.setAttribute('aria-label', 'Åbn kurven, ' + count + (count === 1 ? ' vare' : ' varer'));
    $('[data-cart-empty]').hidden = count > 0;
    $('[data-cart-foot]').hidden = count === 0;
    $('[data-cart-lines]').innerHTML = (cart.items || []).map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=144' : '';
      return '<li class="line">' + (img ? '<img src="' + esc(img) + '" width="72" height="72" loading="lazy" alt="">' : '<span></span>') +
        '<div class="line__info"><p class="line__name">' + esc(it.product_title) + '</p><p class="small muted">' + kr(it.final_price) + ' pr. stk</p>' +
        '<div class="qty" role="group" aria-label="Antal af ' + esc(it.product_title) + '">' +
        '<button type="button" class="icon-btn" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Én færre"><svg class="icon" aria-hidden="true"><use href="#i-minus"/></svg></button>' +
        '<output aria-live="polite">' + it.quantity + '</output>' +
        '<button type="button" class="icon-btn" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Én mere"><svg class="icon" aria-hidden="true"><use href="#i-plus"/></svg></button>' +
        '</div></div><button type="button" class="link-quiet small" data-line="' + (i + 1) + '" data-q="0">Fjern</button></li>';
    }).join('');
    /* Tilkøb: sidens egen regel (window.eleLpUpsell) bestemmer, hvilken boks der vises */
    var show = count && window.eleLpUpsell ? window.eleLpUpsell(cart, qtyOf, C) : null;
    $$('[data-upsell]').forEach(function (u) { u.hidden = u.dataset.upsell !== show; });
    $('[data-cart-sub]').textContent = kr(sub);
    $('[data-cart-shipcost]').textContent = ship ? kr(ship) : '0,00 kr (fri fragt)';
    $('[data-cart-total]').textContent = kr(sub + ship);
    $('[data-ship-bar]').style.width = Math.min(100, Math.round(sub / FREE * 100)) + '%';
    $('[data-ship-text]').textContent = sub > FREE ? 'Du har fri fragt til pakkeshop.' : 'Fri fragt til pakkeshop over ' + kr(FREE).replace(',00', '') + '. Du er ' + kr(FREE - sub) + ' fra.';
  }
  function refreshCart() { return api('cart.js').then(function (c) { cart = c; renderCart(); }).catch(function () {}); }
  function focusables() { return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer).filter(function (el) { return !el.closest('[hidden]'); }); }
  function openCart(ownDrawer) {
    var rb = !ownDrawer && rebuyCart();
    if (rb) { try { if (typeof rb.setCartAsync === 'function') rb.setCartAsync(); } catch (e) {} rb.show(); return; }
    lastFocus = document.activeElement;
    drawer.hidden = false; overlay.hidden = false; document.body.style.overflow = 'hidden';
    var f = focusables(); (f[0] || drawer).focus();
  }
  function closeCart() { drawer.hidden = true; overlay.hidden = true; document.body.style.overflow = ''; showError(''); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); closeCart(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) { e.preventDefault(); return; }
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  overlay.addEventListener('click', closeCart);
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { refreshCart(); openCart(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  $('[data-cart-lines]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]'); if (!b) return;
    b.disabled = true;
    api('cart/change.js', { line: parseInt(b.dataset.line, 10), quantity: Math.max(0, parseInt(b.dataset.q, 10)) })
      .then(function (c) { cart = c; renderCart(); if (!c.item_count) { var x = $('[data-cart-close]'); if (x) x.focus(); } })
      .catch(function (err) { showError(err.message); b.disabled = false; });
  });
  /* Tilkøbsknapper: data-add = "id:antal,id:antal", data-remove = "id" (én færre af den vare) */
  $$('[data-upsell-btn]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      var updates = {};
      if (b.dataset.remove) { var rid = parseInt(b.dataset.remove, 10); updates[rid] = Math.max(0, qtyOf(rid) - 1); }
      b.dataset.add.split(',').forEach(function (p) { var a = p.split(':'), id = parseInt(a[0], 10); updates[id] = (updates[id] != null ? updates[id] : qtyOf(id)) + parseInt(a[1], 10); });
      api('cart/update.js', { updates: updates })
        .then(function (c) { cart = c; renderCart(); track('add_to_cart', Object.keys(updates).map(function (k) { return { id: k, quantity: updates[k] }; }), 0); })
        .catch(function (err) { showError(err.message); })
        .then(function () { b.disabled = false; });
    });
  });

  /* Læg i kurv: købsboks og sticky bruger det valgte; andre formularer deres data-plan */
  $$('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var key = (form.hasAttribute('data-buy-form') || form.hasAttribute('data-sticky-form')) ? selected : (form.dataset.plan || selected);
      var p = PLANS[key], btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      api('cart/add.js', { items: p.items })
        .then(function () { track('add_to_cart', p.items, p.price); return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function (err) { refreshCart().then(function () { openCart(true); showError(err.message); }); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });
  var co = $('[data-checkout]'); if (co) co.addEventListener('click', function () { track('begin_checkout', [], cart.total_price || 0); });

  /* ---------- galleri (video + billeder) ---------- */
  var galVideo = $('[data-gal-video]'), galImg = $('[data-gal-img]');
  $$('.pgal__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('.pgal__thumb').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      if (btn.hasAttribute('data-video') && galVideo) {
        galImg.hidden = true; galVideo.hidden = false;
        if (!reduceMotion) { var pv = galVideo.play(); if (pv && pv.catch) pv.catch(function () {}); }
      } else {
        if (galVideo) { galVideo.pause(); galVideo.hidden = true; }
        galImg.src = btn.dataset.src; galImg.alt = btn.dataset.alt; galImg.hidden = false;
      }
    });
  });


  /* Video-postere under folden hentes først, når de nærmer sig skærmen (sparer ca. 250 KB i første visning) */
  (function () {
    var vs = Array.prototype.slice.call(document.querySelectorAll('video[data-poster]'));
    if (!('IntersectionObserver' in window)) { vs.forEach(function (v) { v.poster = v.getAttribute('data-poster'); }); return; }
    var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.poster = e.target.getAttribute('data-poster'); pio.unobserve(e.target); } }); }, { rootMargin: '800px 0px' });
    vs.forEach(function (v) { pio.observe(v); });
  })();
  /* ---------- videoer ---------- */
  var hero = $('[data-hero-video]');
  if (hero && !reduceMotion) { hero.preload = 'auto'; var hp = hero.play(); if (hp && hp.catch) hp.catch(function () {}); }
  if ('IntersectionObserver' in window && !reduceMotion) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.preload = 'auto'; var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.4 });
    $$('[data-autoplay-inview]').forEach(function (v) { vio.observe(v); });
  }
  $$('.qa video').forEach(function (v) { v.addEventListener('play', function () { $$('.qa video').forEach(function (o) { if (o !== v) o.pause(); }); }); });

  /* ---------- pasform-tjek: sidens egen funktion ---------- */
  if (window.eleLpFit) window.eleLpFit({ $: $, selectPlan: selectPlan });

  /* ---------- sticky bar: vises, når købsknappen ikke er på skærmen ---------- */
  var sticky = $('[data-sticky]'), heroCta = $('[data-hero-cta]');
  function updateSticky() { if (!sticky || !heroCta) return; var b = heroCta.getBoundingClientRect(); sticky.classList.toggle('is-shown', b.bottom < 0 || b.top > window.innerHeight); }
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();

  /* ---------- reveal ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  renderBuy();
  refreshCart();
})();
